import {createBrowserRouter, Route, Routes, useLocation} from 'react-router'
import {Root} from './components/root'
import {routes} from './routes'
import {routes as authRoutes} from '~/cores/auth/routes'
import {ProtectedRoute} from './components/protected_route'

const appRoutes = (
	<Route element={<ProtectedRoute />}>
		<Route element={<Root />}>{routes}</Route>
	</Route>
)

const modalRoutes = <Route element={<ProtectedRoute />}>{routes}</Route>

const CustomRouter = () => {
	const location = useLocation()
	const background = location.state?.background

	return (
		<>
			<Routes location={background || location}>
				{authRoutes}
				{appRoutes}
			</Routes>
			{background && <Routes>{modalRoutes}</Routes>}
		</>
	)
}

export const router = createBrowserRouter([
	{
		path: '*', // wildcard to match all routes; needed for modal routing
		element: <CustomRouter />,
	},
])
